import axios from 'axios';
import { IUsersCollectionDto } from 'entities/Users/Users.models';

const basePath = 'user';

export const usersTransport = {
  getUsersCollection: (): Promise<IUsersCollectionDto> => axios.get(`${basePath}`),
};
